import { stringify } from './helpers/querystring';
import { useAppConfig } from '../AppConfig';

// TODO: This should probably be /login but that will conflict with what we're
// redirecting to in prod, after pre-auth.
const authPageLocal = '/auth';

export function useAuthPageUrl() {
  const { environment } = useAppConfig();
  const authPage = environment?.authPage || authPageLocal;
  return (next: string) => {
    const queryString = stringify({ next }, '?');
    return authPage + queryString;
  };
}
